import chroma from 'chroma-js';
import { Transformation } from 'cloudinary-core';
import React, { ImgHTMLAttributes } from 'react';

import { Image, Pdf } from 'generated/graphql';

import { ImageSizeValues } from 'lib/mediaThresholds';

import MediaImage from '../MediaImage';
import { useStyles, Theme } from './styles';

const colors = chroma.scale(['#F4EAE1', '#EBE8E6', '#DEAB86']).mode('lch').colors(20);

export type ComponentProps = {
	image: Image | Pdf;
	className?: string;
	imageOptions?: Transformation.Options;
	sizes?: ImageSizeValues;
	onClick?(): void;
	label?: string;
	attributes?: Omit<ImgHTMLAttributes<HTMLImageElement>, 'className' | 'src' | 'onLoad' | 'srcSet' | 'sizes' | 'onClick'>;
};

const ShowroomImage = ({ image, sizes, onClick = null, attributes, label = '', className }: ComponentProps) => {
	const color = React.useMemo(() => colors[Math.floor(Math.random() * 19)], []);
	const classes = useStyles({ clickable: !!onClick });

	const theme = Theme();

	return (
		<MediaImage
			id={`showroomImage_${image.id}`}
			media={image}
			imageAttributes={attributes}
			onClick={onClick}
			containerClassName={classes.pictureBox}
			imgClassName={className}
			placeholderColor={color}
			sizes={sizes}
			mobileBreakpoint={theme.breakpoints.values.md - 0.05}
		/>
	);
};

export default React.memo(ShowroomImage);
